import {
    SET_USER_LOGGED_IN,
    SET_USER_AUTH_DATA,
    SET_KYC_AND_SETTLEMENT,
    RESET_STATE
} from './auth.type'

export const setUserLoggedIn = (data: boolean) => ({
    type: SET_USER_LOGGED_IN,
    payload:data
})

export const setAuthRes = (data: any[]) => ({
    type: SET_USER_AUTH_DATA,
    payload: data
})

export const setKycAndSettlement = (data: any[]) => ({
    type: SET_KYC_AND_SETTLEMENT,
    payload: data
})

export const logoutHandler = () => ({
    type: RESET_STATE
})